// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-event-card {
    max-width: 500px;
    margin: 0 auto;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    text-align: center;
  }
  
  .delete-event-title {
    font-size: 1.8rem;
    font-weight: bold;
    color: white;
    margin-bottom: 20px;
  }
  
  .delete-event-select {
    margin-bottom: 20px;
  }
  
  .event-select-dropdown {
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .delete-event-button {
    padding: 12px;
    font-size: 1rem;
    font-weight: bold;
    color: white;
    background-color: black;
    border: 1px solid white;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .delete-event-button:hover {
    background-color: #555;
  }
  
  .delete-status-message {
    margin-top: 15px;
    font-size: 1rem;
    color: #333;
  }
  `, "",{"version":3,"sources":["webpack://./src/private/Admin/EventDeleteForm.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb","sourcesContent":[".delete-event-card {\r\n    max-width: 500px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n    text-align: center;\r\n  }\r\n  \r\n  .delete-event-title {\r\n    font-size: 1.8rem;\r\n    font-weight: bold;\r\n    color: white;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .delete-event-select {\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .event-select-dropdown {\r\n    width: 100%;\r\n    padding: 10px;\r\n    font-size: 1rem;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .delete-event-button {\r\n    padding: 12px;\r\n    font-size: 1rem;\r\n    font-weight: bold;\r\n    color: white;\r\n    background-color: black;\r\n    border: 1px solid white;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .delete-event-button:hover {\r\n    background-color: #555;\r\n  }\r\n  \r\n  .delete-status-message {\r\n    margin-top: 15px;\r\n    font-size: 1rem;\r\n    color: #333;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
